import { render } from "./ExamTrendChartCard.vue?vue&type=template&id=bc1a245c&scoped=true"
import script from "./ExamTrendChartCard.vue?vue&type=script&lang=js"
export * from "./ExamTrendChartCard.vue?vue&type=script&lang=js"

import "./ExamTrendChartCard.vue?vue&type=style&index=0&id=bc1a245c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc1a245c"]])

export default __exports__